
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const StructuredData = () => {
  const location = useLocation();

  useEffect(() => {
    // LocalBusiness Schema
    const localBusinessSchema = {
      '@context': 'https://schema.org',
      '@type': 'ProfessionalService',
      name: 'JUSTCLEAN DEFUNCIÓN BARCELONA',
      image: 'https://public.readdy.ai/ai/img_res/b3383ad1-a901-4a46-8311-960bbaeb48b2.png',
      '@id': 'https://defuncion.justclean.es',
      url: 'https://defuncion.justclean.es',
      telephone: '+34602365996',
      email: 'info@defuncion.justclean.es',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Barcelona',
        addressLocality: 'Barcelona',
        addressRegion: 'Cataluña',
        postalCode: '08001',
        addressCountry: 'ES',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 41.3874,
        longitude: 2.1686,
      },
      areaServed: [
        {
          '@type': 'City',
          name: 'Barcelona',
        },
        {
          '@type': 'AdministrativeArea',
          name: 'Provincia de Barcelona',
        },
      ],
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
          opens: '00:00',
          closes: '23:59',
        },
      ],
      priceRange: '€€',
    };

    // Service Schema
    const serviceSchema = {
      '@context': 'https://schema.org',
      '@type': 'Service',
      serviceType: 'Limpieza por Defunción',
      provider: {
        '@type': 'ProfessionalService',
        name: 'JUSTCLEAN DEFUNCIÓN BARCELONA',
      },
      areaServed: {
        '@type': 'City',
        name: 'Barcelona',
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Servicios de Limpieza Especializada',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Limpieza Post Mortem',
              description: 'Limpieza profesional tras defunción en domicilios',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Desinfección Profesional',
              description: 'Desinfección y saneamiento según necesidad',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Eliminación de Olores',
              description: 'Neutralización de olores persistentes',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Retirada de Enseres',
              description: 'Vaciado y retirada de muebles y enseres',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Limpieza de Choque',
              description: 'Limpieza profunda en casos de suciedad extrema',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Preparación de Inmueble',
              description: 'Preparación para entrega, venta o alquiler',
            },
          },
        ],
      },
    };

    // Insert schemas
    let script1 = document.getElementById('schema-local-business');
    if (!script1) {
      script1 = document.createElement('script');
      script1.id = 'schema-local-business';
      script1.type = 'application/ld+json';
      document.head.appendChild(script1);
    }
    script1.textContent = JSON.stringify(localBusinessSchema);

    let script2 = document.getElementById('schema-service');
    if (!script2) {
      script2 = document.createElement('script');
      script2.id = 'schema-service';
      script2.type = 'application/ld+json';
      document.head.appendChild(script2);
    }
    script2.textContent = JSON.stringify(serviceSchema);
  }, [location]);

  return null;
};

export default StructuredData;
